import React, { useEffect, useState } from "react";
import QuizBanner from "./quizBanner";
import QuizLeaderboard from "./quizLeaderboard";
import trophy from "../../../template/images/Trophy.svg";
import keepGoing from "../../../template/images/keep-going.png";
import OtherQuizes from "./otherQuizes";
import { useLocation, useNavigate } from "react-router-dom";
import happyFace from "../../../template/images/happy-icon.svg";
import sadFace from "../../../template/images/sad-icon.svg";
import ShareButtons from "../../layout/shareButtons";
import sadIcon from "../../../template/images/cross-icon.svg";
import happyIcon from "../../../template/images/tick-icon.svg";
import { useParams } from "react-router-dom";

function QuizComplete() {
  const { id, topic } = useParams();
  const shareUrl = 'https://finlabsweb.finlabsindia.org/Quiz';
  const title = 'Check out this amazing website!';

  const navigate = useNavigate();
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const toggleAccordion = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };
  const location = useLocation();
  const { result } = location.state || {};
  const { totalMarks, questionResults } = result;

  useEffect(() => {
    if (result) {
      // Store totalMarks in localStorage
      localStorage.setItem("totalMarks", totalMarks);
    }
  }, [result, totalMarks]);

  console.log(result.status, "status");

  if (!result) {
    return <div>No data to display</div>;
  }

  const handleRetakeQuiz = () => {
    navigate(`/quiz/${id}/${topic}`);
  };
  // Helper function to convert 0/1 to False/True
  const convertToTrueFalse = (answer) => {
    return answer === "1" ? "True" : answer === "0" ? "False" : answer;
  };
  return (
    <>
      <QuizBanner />
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-12 col-md-6">
            {result.status === "fail" ? (
              <>
                <div className="pass-section">
                  <div className="points-section">
                    <img src={keepGoing} alt="Keep Going" />
                    <span className="cong-text">Keep Going! </span>
                    <span className="points-got">
                      You scored{" "}
                      <span className="point-got-no">{totalMarks}</span> Quiz
                      Points
                    </span>
                    <div className="retake-section">
                      <span>Retake the Quiz to Boost Your Score.</span>
                      <button
                        className="re-quiz-btn"
                        onClick={handleRetakeQuiz}
                      >
                        Retake Quiz
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="pass-section">
                  <div className="points-section">
                    <img src={trophy} alt="Trophy" />
                    <span className="cong-text">Congratulations</span>
                    <span className="points-got">
                      You scored {totalMarks} Quiz Points
                    </span>
                    <div>
                      <ShareButtons url={shareUrl} title={title}/>
                    </div>
                    <div className="retake-section">
                      <span>Retake the Quiz to Boost Your Score.</span>
                      <button
                        className="re-quiz-btn"
                        onClick={handleRetakeQuiz}
                      >
                        Retake Quiz
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
            <OtherQuizes />
          </div>
          <div className="col-12 col-md-5">
            <div className="quiz-graph">
              <h4 className="graph-heading">Performance</h4>
              <div className="questions-emoji">
                {questionResults &&
                  questionResults.map((question, index) => (
                    <span key={index} className="emoji-response">
                      {/* <span className="emoji-icon">
                      <img
                          src={question.correct ? happyIcon : sadIcon}
                          alt={question.correct ? "Happy Icon" : "Sad Icon"}
                        />
                  
                      </span> */}
                      <span className="face">
                        <img
                          src={question.correct ? happyFace : sadFace}
                          alt={question.correct ? "Happy Face" : "Sad Face"}
                        />
                      </span>
                      {/* <span className="face">
                     { question.correct ?
                      <i class="fa fa-smile-o"></i>
                      :
                      <i className="fa fa-frown-o"></i>
                     }
                      </span> */}
                      <span className="face-no">{index + 1}</span>
                    </span>
                  ))}
              </div>
              <div className="view-correct-answer">
                <div className="view-ans-accor-item" onClick={toggleAccordion}>
                  <span className="view-ans-text">View Correct Answers</span>
                  <span>
                    <i
                      className={`fa fa-chevron-down ${
                        isAccordionOpen ? "rotate" : ""
                      }`}
                    ></i>
                  </span>
                </div>
                {isAccordionOpen && (
                  <div className="view-ans-desc">
                    {questionResults.map((question, index) => (
                      <div key={index} className="question-set">
                        <span className="view-question-text">
                          Q {index + 1}. {question.question}
                        </span>
                        {question.correct ? (
                          <span className="view-ans-text-resp">
                            Your Ans.{" "}
                            <span
                              className={`${
                                question.correct ? "correct" : "incorrect"
                              }`}
                            >
                              {convertToTrueFalse(question.submittedAnswer)}
                            </span>
                          </span>
                        ) : (
                          <span className="view-ans-text-resp">
                            Your Ans.{" "}
                            <span
                              className={`${
                                question.correct ? "correct" : "incorrect"
                              }`}
                            >
                              {convertToTrueFalse(question.submittedAnswer)}
                            </span>
                          </span>
                        )}
                        <span className="view-ans-text-resp">
                          Ans.{" "}
                          <span
                            className={`${
                              question.correct ? "correct" : "correct"
                            }`}
                          >
                            {convertToTrueFalse(question.correctAnswer)}
                          </span>
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <QuizLeaderboard />
          </div>
        </div>
      </div>
    </>
  );
}

export default QuizComplete;
